import styled from "styled-components";

export const SkeletonRoot = styled.div.attrs({})`
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
  padding: 32px clamp(18px, 3vw, 40px) 56px;
`;

export const SkeletonHeader = styled.div.attrs({})`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
  padding-bottom: 28px;
  border-bottom: 1px solid ${props => props.theme.palette.colors.borderSoft};

  @media (max-width: 991px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const SkeletonHeaderMain = styled.div.attrs({})`
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
`;

export const SkeletonActions = styled.div.attrs({})`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 12px;
`;

export const SkeletonGrid = styled.div.attrs({})`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
`;

export const SkeletonCard = styled.div.attrs({})`
  position: relative;
  min-height: 258px;
  overflow: hidden;
  border-radius: 20px;
`;

export const SkeletonCardOverlay = styled.div.attrs({})`
  position: absolute;
  inset: auto 18px 18px 18px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
